// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Header UX CSS Classes
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
:root {
  /* Variable ezAlphaBackgroundWhite2 from ez-body.css */
  --ezPublicHeaderBackgroundColor: var(--ezAlphaBackgroundWhite2);
  --ezHeaderBackgroundColor: var(--ezAlphaBackgroundWhite2);
  /* Variables for fonts from ez-text.css */
  --ezPublicHeaderFontColor: var(--ezBannerHeaderColor);
  --ezPublicHeaderFontFamily: var(--ezFontFamily);
  --ezPublicHeaderFontSize: var(--ezBannerHeaderFontSize);
  --ezPublicHeaderFontWeight: var(--ezBannerHeaderFontWeight);
  --ezHeaderFontColor: var(--ezBannerHeaderColor);
  --ezHeaderFontFamily: var(--ezFontFamily);
  --ezHeaderFontSize: var(--ezBannerHeaderFontSize);
  --ezHeaderFontWeight: var(--ezBannerHeaderFontWeight);
  /* Variables for fonts from ez-text.css */
  --ezPublicSubHeaderFontColor: var(--ezTitleFontColor);
  --ezPublicSubHeaderFontSize: var(--ezHeaderFontSize);
  --ezSubHeaderFontColor: var(--ezTitleFontColor);
  --ezSubHeaderFontSize: var(--ezHeaderFontSize);
  /* Variables for borders from ez-borders.css */
  --ezPublicHeaderBorderColor: var(--ezBorderColorBlack);
  --ezPublicHeaderBorderStyle: var(--ezBorderStyle);
  --ezPublicHeaderBorderSize: var(--ezBorderWidth);
  --ezHeaderBorderColor: var(--ezBorderColorBlack);
}

/* -------------------------------------------------------------------
| Desktop Screen Styles (default)                                   |
------------------------------------------------------------------- */
app-header {
  background-color: var(--ezHeaderBackgroundColor);
  --app-header-background-rear-layer: {
      /* The header is blue when condensed */
      background-color: blue;
  };
  --app-header-shadow: {
          box-shadow: inset 0 5px 2px -3px rgb(0 0 0 / 20%) ;
  } ;
}

.ezHeader-mobile {
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: min-content;
  align-content: stretch;
  padding: 8px;
  /* Background variable from ez-header.css :root (this file) */
  background-color: var(--ezClockerWhite);
  /* Font variables from ez-header.css :root (this file) */
  color: var(--ezPublicHeaderFontColor);
  font-family: var(--ezPublicHeaderFontFamily);
  font-size: var(--ezPublicHeaderFontSize);
  font-weight: var(--ezPublicHeaderFontWeight);
}

/* Public page header */
.ezHeader-public {
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: min-content;
  padding: 8px;
  /* Background variable from ez-header.css :root (this file) */
  background-color: var(--ezPublicHeaderBackgroundColor);
  /* Font variables from ez-header.css :root (this file) */
  color: var(--ezPublicHeaderFontColor);
  font-family: var(--ezPublicHeaderFontFamily);
  font-size: var(--ezPublicHeaderFontSize);
  font-weight: var(--ezPublicHeaderFontWeight);
  /* Border variables from ez-header.css :root (this file) */
  border-bottom-color: var(--ezPublicHeaderBorderColor);
  border-bottom-style: var(--ezPublicHeaderBorderStyle);
  border-bottom-width: var(--ezPublicHeaderBorderSize);
  box-shadow: 0 2px 2px 0 rgb(109 110 112/50%);
  transition: 200ms ease-in-out;
  transform-origin: center top;
  transform: none;
}

.ezHeader-public-logo {
  min-height: 62px;
  padding: 4px;
  /* Background variable from ez-header.css :root (this file) */
  background-color: var(--ezPublicHeaderBackgroundColor);
  background-image: url("/public/images/logos/ezclocker_logo_2015.svg");
  background-position-x: left;
  background-position-y: center;
  background-repeat: no-repeat;
  background-size: 250px;
  background-clip: content-box;
  /* Font variables from ez-header.css :root (this file) */
  color: var(--ezPublicHeaderFontColor);
  font-family: var(--ezPublicHeaderFontFamily);
  font-size: var(--ezPublicHeaderFontSize);
  font-weight: var(--ezPublicHeaderFontWeight);
  /* Border variables from ez-header.css :root (this file) */
  border-bottom-color: var(--ezPublicHeaderBorderColor);
  border-bottom-style: var(--ezPublicHeaderBorderStyle);
  border-bottom-width: var(--ezPublicHeaderBorderSize);
  box-shadow: 0 2px 2px 0 rgb(109 110 112/50%);
  transition: 200ms ease-in-out;
  transform-origin: center top;
  transform: none;
}

.ezHeader-public-ezclocker-logo-container {
  display: grid;
  grid-template-columns: min-content auto;
  justify-content: start;
  align-content: center;
}

.ezHeader-public-ezclocker-logo-image-container {
  display: grid;
  margin-right: 8px;
  align-content: center;
  justify-content: start;
}

.ezHeader-public-ezclocker-logo-image {
  max-width: 250px;
  padding: 0;
  margin: 0;
  margin-right: 8px;
  border-style: none;
}

/* Secure page header */
.ezHeader {
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: min-content;
  padding-top: 4px;
  padding-left: 6px;
  padding-right: 6px;
  padding-bottom: 4px;
  background-color: rgb(255 255 255/40%);
  color: var(--ezClockerBlack);
  font-family: Roboto, Verdana, sans-serif;
  font-weight: normal;
  font-size: 32pt;
  border-bottom-color: var(--ezClockerBlack);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  box-shadow: 0 2px 2px 0 rgb(109 110 112/50%);
}

/* Secure page header */
.ezHeader-fixed {
  display: grid;
  position: sticky;
  grid-template-columns: auto auto;
  grid-template-rows: min-content;
  padding-left: 4px;
  padding-right: 4px;
  background-color: rgb(255 255 255/40%);
  color: var(--ezClockerBlack);
  font-family: Roboto, Verdana, sans-serif;
  font-weight: normal;
  font-size: 32pt;
  border-bottom-color: var(--ezClockerBlack);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  box-shadow: 0 2px 2px 0 rgb(109 110 112/50%);
}

.ezHeader-employer-logo-container {
  display: grid;
  grid-template-columns: min-content auto;
  justify-content: start;
  align-content: center;
}

.ezHeader-logo-image-container {
  display: grid;
  margin-right: 8px;
  align-content: center;
  justify-content: start;
}

.ezHeader-employer-logo {
  margin: 0;
  max-width: 110px;
  max-height: 40px;
  font-size: 8px;
}

.ezHeader-employer-name {
  display: grid;
  align-content: center;
  justify-content: start;
  border-style: none;
  /* Variables from ez-text.css */
  color: var(--ezBannerHeaderColor);
  font-family: var(--ezFontFamily);
  font-weight: var(--ezBannerHeaderFontWeight);
  font-size: var(--ezBannerHeaderFontSize);
}

.ezHeader-navigation-button-container {
  display: grid;
  grid-auto-flow: column;
  column-gap: 4px;
  justify-content: end;
  align-content: center;
}

img.ez-header-employer-logo-spinner {
  padding: 2px;
  border-style: none;
  vertical-align: middle;
  max-width: 110px;
  max-height: 40px;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  margin-right: 10px;
}

div.ez-header-employer-name-text {
  font-size: 18pt;
  font-weight: bold;
}

div.ez-header-page-name-text {
  color: var(--ezClockerBlack);
  font-size: 12pt;
}

.ezPageHeader {
  padding-left: 4px;
  padding-right: 4px;
  padding-bottom: 8px;
  background-color: rgb(255 255 255/40%);
  color: var(--ezClockerBlack);
  font-family: Roboto, Verdana, sans-serif;
  font-weight: normal;
  font-size: 32pt;
  border-bottom-color: var(--ezClockerBlack);
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

.ezPageHeader-ezClockerWhite {
  padding-left: 4px;
  padding-right: 4px;
  padding-bottom: 8px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  font-family: Roboto, Verdana, sans-serif;
  font-weight: normal;
  font-size: 32pt;
  border-bottom-color: var(--ezClockerBlack);
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

.ezPageHeaderLogo {
  max-width: 250px;
  border-style: none;
  padding: 8px;
  margin: 0;
  vertical-align: middle;
}

/* -------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 1023px) {
}
*/
/* -------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 768px) {
}
*/
/* -------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 480px) {
}
*/
/* -------------------------------------------------------------------
| Warable Screen Style  (https://yesviz.com/watches.php)            |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 319px) {
}
*/`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-header.css"],"names":[],"mappings":"AAAA;;;iEAAA;AAIA;EACI,sDAAA;EACA,+DAAA;EACA,yDAAA;EAEA,yCAAA;EACA,qDAAA;EACA,+CAAA;EACA,uDAAA;EACA,2DAAA;EACA,+CAAA;EACA,yCAAA;EACA,iDAAA;EACA,qDAAA;EAEA,yCAAA;EACA,qDAAA;EACA,oDAAA;EACA,+CAAA;EACA,8CAAA;EAEA,8CAAA;EACA,sDAAA;EACA,iDAAA;EACA,gDAAA;EACA,gDAAA;AAFJ;;AAKA;;qEAAA;AAGA;EACI,gDAAA;EAEA;;;GAAA;EAKA;;IAAA;AAFJ;;AAOA;EACI,aAAA;EACA,gCAAA;EACA,+BAAA;EACA,sBAAA;EACA,YAAA;EAEA,6DAAA;EACA,uCAAA;EAEA,wDAAA;EACA,qCAAA;EACA,4CAAA;EACA,wCAAA;EACA,4CAAA;AANJ;;AASA,uBAAA;AACA;EACI,aAAA;EACA,gCAAA;EACA,+BAAA;EACA,YAAA;EAGA,6DAAA;EACA,sDAAA;EAEA,wDAAA;EACA,qCAAA;EACA,4CAAA;EACA,wCAAA;EACA,4CAAA;EAEA,0DAAA;EACA,qDAAA;EACA,qDAAA;EACA,oDAAA;EACA,4CAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;AAVJ;;AAaA;EACI,gBAAA;EACA,YAAA;EAEA,6DAAA;EACA,sDAAA;EACA,qEAAA;EACA,2BAAA;EACA,6BAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EAEA,wDAAA;EACA,qCAAA;EACA,4CAAA;EACA,wCAAA;EACA,4CAAA;EAEA,0DAAA;EACA,qDAAA;EACA,qDAAA;EACA,oDAAA;EACA,4CAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;AAbJ;;AAgBA;EACI,aAAA;EACA,uCAAA;EACA,sBAAA;EACA,qBAAA;AAbJ;;AAgBA;EACI,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AAbJ;;AAgBA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;AAbJ;;AAgBA,uBAAA;AACA;EACI,aAAA;EACA,gCAAA;EACA,+BAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sCAAA;EACA,4BAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,0BAAA;EACA,wBAAA;EACA,4CAAA;AAbJ;;AAgBA,uBAAA;AACA;EACI,aAAA;EACA,gBAAA;EACA,gCAAA;EACA,+BAAA;EACA,iBAAA;EACA,kBAAA;EACA,sCAAA;EACA,4BAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,0BAAA;EACA,wBAAA;EACA,4CAAA;AAbJ;;AAgBA;EACI,aAAA;EACA,uCAAA;EACA,sBAAA;EACA,qBAAA;AAbJ;;AAgBA;EACI,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AAbJ;;AAgBA;EACI,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAbJ;;AAgBA;EACI,aAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EAEA,+BAAA;EACA,iCAAA;EACA,gCAAA;EACA,4CAAA;EACA,wCAAA;AAdJ;;AAiBA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,oBAAA;EACA,qBAAA;AAdJ;;AAiBA;EACI,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;AAdJ;;AAiBA;EACI,eAAA;EACA,iBAAA;AAdJ;;AAiBA;EACI,4BAAA;EACA,eAAA;AAdJ;;AAiBA;EACI,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sCAAA;EACA,4BAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,0BAAA;EACA,wBAAA;AAdJ;;AAiBA;EACI,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uCAAA;EACA,4BAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,0BAAA;EACA,wBAAA;AAdJ;;AAiBA;EACI,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,sBAAA;AAdJ;;AAiBA;;qEAAA;AAGA;;;CAAA;AAMA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| EzClocker Header UX CSS Classes\r\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n:root {\r\n    /* Variable ezAlphaBackgroundWhite2 from ez-body.css */\r\n    --ezPublicHeaderBackgroundColor: var(--ezAlphaBackgroundWhite2);\r\n    --ezHeaderBackgroundColor: var(--ezAlphaBackgroundWhite2);\r\n\r\n    /* Variables for fonts from ez-text.css */\r\n    --ezPublicHeaderFontColor: var(--ezBannerHeaderColor);\r\n    --ezPublicHeaderFontFamily: var(--ezFontFamily);\r\n    --ezPublicHeaderFontSize: var(--ezBannerHeaderFontSize);\r\n    --ezPublicHeaderFontWeight: var(--ezBannerHeaderFontWeight);\r\n    --ezHeaderFontColor: var(--ezBannerHeaderColor);\r\n    --ezHeaderFontFamily: var(--ezFontFamily);\r\n    --ezHeaderFontSize: var(--ezBannerHeaderFontSize);\r\n    --ezHeaderFontWeight: var(--ezBannerHeaderFontWeight);\r\n\r\n    /* Variables for fonts from ez-text.css */\r\n    --ezPublicSubHeaderFontColor: var(--ezTitleFontColor);\r\n    --ezPublicSubHeaderFontSize: var(--ezHeaderFontSize);\r\n    --ezSubHeaderFontColor: var(--ezTitleFontColor);\r\n    --ezSubHeaderFontSize: var(--ezHeaderFontSize);\r\n\r\n    /* Variables for borders from ez-borders.css */\r\n    --ezPublicHeaderBorderColor: var(--ezBorderColorBlack);\r\n    --ezPublicHeaderBorderStyle: var(--ezBorderStyle);\r\n    --ezPublicHeaderBorderSize: var(--ezBorderWidth);\r\n    --ezHeaderBorderColor: var(--ezBorderColorBlack);\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Desktop Screen Styles (default)                                   |\r\n------------------------------------------------------------------- */\r\napp-header {\r\n    background-color: var(--ezHeaderBackgroundColor);\r\n\r\n    --app-header-background-rear-layer: {\r\n        /* The header is blue when condensed */\r\n        background-color: blue;\r\n    };\r\n\r\n    --app-header-shadow: {\r\n            box-shadow: inset 0 5px 2px -3px rgb(0 0 0 / 20%) ;\r\n    }\r\n}\r\n\r\n.ezHeader-mobile {\r\n    display: grid;\r\n    grid-template-columns: auto auto;\r\n    grid-template-rows: min-content;\r\n    align-content: stretch;\r\n    padding: 8px;\r\n\r\n    /* Background variable from ez-header.css :root (this file) */\r\n    background-color: var(--ezClockerWhite);\r\n\r\n    /* Font variables from ez-header.css :root (this file) */\r\n    color: var(--ezPublicHeaderFontColor);\r\n    font-family: var(--ezPublicHeaderFontFamily);\r\n    font-size: var(--ezPublicHeaderFontSize);\r\n    font-weight: var(--ezPublicHeaderFontWeight);\r\n}\r\n\r\n/* Public page header */\r\n.ezHeader-public {\r\n    display: grid;\r\n    grid-template-columns: auto auto;\r\n    grid-template-rows: min-content;\r\n    padding: 8px;\r\n\r\n\r\n    /* Background variable from ez-header.css :root (this file) */\r\n    background-color: var(--ezPublicHeaderBackgroundColor);\r\n\r\n    /* Font variables from ez-header.css :root (this file) */\r\n    color: var(--ezPublicHeaderFontColor);\r\n    font-family: var(--ezPublicHeaderFontFamily);\r\n    font-size: var(--ezPublicHeaderFontSize);\r\n    font-weight: var(--ezPublicHeaderFontWeight);\r\n\r\n    /* Border variables from ez-header.css :root (this file) */\r\n    border-bottom-color: var(--ezPublicHeaderBorderColor);\r\n    border-bottom-style: var(--ezPublicHeaderBorderStyle);\r\n    border-bottom-width: var(--ezPublicHeaderBorderSize);\r\n    box-shadow: 0 2px 2px 0 rgb(109 110 112 / 50%);\r\n    transition: 200ms ease-in-out;\r\n    transform-origin: center top;\r\n    transform: none;\r\n}\r\n\r\n.ezHeader-public-logo {\r\n    min-height: 62px;\r\n    padding: 4px;\r\n\r\n    /* Background variable from ez-header.css :root (this file) */\r\n    background-color: var(--ezPublicHeaderBackgroundColor);\r\n    background-image: url('/public/images/logos/ezclocker_logo_2015.svg');\r\n    background-position-x: left;\r\n    background-position-y: center;\r\n    background-repeat: no-repeat;\r\n    background-size: 250px;\r\n    background-clip: content-box;\r\n\r\n    /* Font variables from ez-header.css :root (this file) */\r\n    color: var(--ezPublicHeaderFontColor);\r\n    font-family: var(--ezPublicHeaderFontFamily);\r\n    font-size: var(--ezPublicHeaderFontSize);\r\n    font-weight: var(--ezPublicHeaderFontWeight);\r\n\r\n    /* Border variables from ez-header.css :root (this file) */\r\n    border-bottom-color: var(--ezPublicHeaderBorderColor);\r\n    border-bottom-style: var(--ezPublicHeaderBorderStyle);\r\n    border-bottom-width: var(--ezPublicHeaderBorderSize);\r\n    box-shadow: 0 2px 2px 0 rgb(109 110 112 / 50%);\r\n    transition: 200ms ease-in-out;\r\n    transform-origin: center top;\r\n    transform: none;\r\n}\r\n\r\n.ezHeader-public-ezclocker-logo-container {\r\n    display: grid;\r\n    grid-template-columns: min-content auto;\r\n    justify-content: start;\r\n    align-content: center;\r\n}\r\n\r\n.ezHeader-public-ezclocker-logo-image-container {\r\n    display: grid;\r\n    margin-right: 8px;\r\n    align-content: center;\r\n    justify-content: start;\r\n}\r\n\r\n.ezHeader-public-ezclocker-logo-image {\r\n    max-width: 250px;\r\n    padding: 0;\r\n    margin: 0;\r\n    margin-right: 8px;\r\n    border-style: none;\r\n}\r\n\r\n/* Secure page header */\r\n.ezHeader {\r\n    display: grid;\r\n    grid-template-columns: auto auto;\r\n    grid-template-rows: min-content;\r\n    padding-top: 4px;\r\n    padding-left: 6px;\r\n    padding-right: 6px;\r\n    padding-bottom: 4px;\r\n    background-color: rgb(255 255 255 / 40%);\r\n    color: var(--ezClockerBlack);\r\n    font-family: Roboto, Verdana, sans-serif;\r\n    font-weight: normal;\r\n    font-size: 32pt;\r\n    border-bottom-color: var(--ezClockerBlack);\r\n    border-bottom-style: solid;\r\n    border-bottom-width: 1px;\r\n    box-shadow: 0 2px 2px 0 rgb(109 110 112 / 50%);\r\n}\r\n\r\n/* Secure page header */\r\n.ezHeader-fixed {\r\n    display: grid;\r\n    position: sticky;\r\n    grid-template-columns: auto auto;\r\n    grid-template-rows: min-content;\r\n    padding-left: 4px;\r\n    padding-right: 4px;\r\n    background-color: rgb(255 255 255 / 40%);\r\n    color: var(--ezClockerBlack);\r\n    font-family: Roboto, Verdana, sans-serif;\r\n    font-weight: normal;\r\n    font-size: 32pt;\r\n    border-bottom-color: var(--ezClockerBlack);\r\n    border-bottom-style: solid;\r\n    border-bottom-width: 1px;\r\n    box-shadow: 0 2px 2px 0 rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ezHeader-employer-logo-container {\r\n    display: grid;\r\n    grid-template-columns: min-content auto;\r\n    justify-content: start;\r\n    align-content: center;\r\n}\r\n\r\n.ezHeader-logo-image-container {\r\n    display: grid;\r\n    margin-right: 8px;\r\n    align-content: center;\r\n    justify-content: start;\r\n}\r\n\r\n.ezHeader-employer-logo {\r\n    margin: 0;\r\n    max-width: 110px;\r\n    max-height: 40px;\r\n    font-size: 8px;\r\n}\r\n\r\n.ezHeader-employer-name {\r\n    display: grid;\r\n    align-content: center;\r\n    justify-content:start;\r\n    border-style: none;\r\n\r\n    /* Variables from ez-text.css */\r\n    color: var(--ezBannerHeaderColor);\r\n    font-family: var(--ezFontFamily);\r\n    font-weight: var(--ezBannerHeaderFontWeight);\r\n    font-size: var(--ezBannerHeaderFontSize);\r\n}\r\n\r\n.ezHeader-navigation-button-container {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    column-gap: 4px;\r\n    justify-content: end;\r\n    align-content: center;\r\n}\r\n\r\nimg.ez-header-employer-logo-spinner {\r\n    padding: 2px;\r\n    border-style: none;\r\n    vertical-align: middle;\r\n    max-width: 110px;\r\n    max-height: 40px;\r\n    border-top-right-radius: 4px;\r\n    border-top-left-radius: 4px;\r\n    margin-right: 10px;\r\n}\r\n\r\ndiv.ez-header-employer-name-text {\r\n    font-size: 18pt;\r\n    font-weight: bold;\r\n}\r\n\r\ndiv.ez-header-page-name-text {\r\n    color: var(--ezClockerBlack);;\r\n    font-size: 12pt;\r\n}\r\n\r\n.ezPageHeader {\r\n    padding-left: 4px;\r\n    padding-right: 4px;\r\n    padding-bottom: 8px;\r\n    background-color: rgb(255 255 255 / 40%);\r\n    color: var(--ezClockerBlack);;\r\n    font-family: Roboto, Verdana, sans-serif;\r\n    font-weight: normal;\r\n    font-size: 32pt;\r\n    border-bottom-color: var(--ezClockerBlack);;\r\n    border-bottom-style: solid;\r\n    border-bottom-width: 1px;\r\n}\r\n\r\n.ezPageHeader-ezClockerWhite {\r\n    padding-left: 4px;\r\n    padding-right: 4px;\r\n    padding-bottom: 8px;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerBlack);;\r\n    font-family: Roboto, Verdana, sans-serif;\r\n    font-weight: normal;\r\n    font-size: 32pt;\r\n    border-bottom-color: var(--ezClockerBlack);;\r\n    border-bottom-style: solid;\r\n    border-bottom-width: 1px;\r\n}\r\n\r\n.ezPageHeaderLogo {\r\n    max-width: 250px;\r\n    border-style: none;\r\n    padding: 8px;\r\n    margin: 0;\r\n    vertical-align: middle;\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 1023px) {\r\n}\r\n*/\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 768px) {\r\n}\r\n*/\r\n\r\n/* -------------------------------------------------------------------\r\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 480px) {\r\n}\r\n*/\r\n\r\n/* -------------------------------------------------------------------\r\n| Warable Screen Style  (https://yesviz.com/watches.php)            |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 319px) {\r\n}\r\n*/\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
